import {
	requests
}from '../../../../api/agent'

export default {
	createReportHierarchy  : (params) => requests.post('/reReportHierarchy/create', params),
	deleteReportHierarchy  : (params) => requests.post('/reReportHierarchy/delete', params),
	getAllPaged            : (params) => requests.getWithParams('/reReportHierarchy/getAllPaged', params),
	restoreReportHierarchy : (params) => requests.post('/reReportHierarchy/restore', params),
	updateReportHierarchy  : (params) => requests.post('/reReportHierarchy/update', params)
}